import { useContext, useCallback } from "react";
import GlobalModalContext from "../../contexts/GlobalModalContext";

export const useDiscardChanges = () => {
  const globalModalContext = useContext(GlobalModalContext);
  const { dispatch } = globalModalContext;

  return useCallback(discardChangesFn => dispatch({ type: "openAreYouSureModal", discardChangesFn }), [dispatch]);
};
